import React, { useEffect, useState } from 'react';
import SVG from '../SVG.jsx';

export default function ResultAnimation(props) {
  const { advanceForm } = props;
  const [animationOneComplete, setAnimationOneComplete] = useState(false);
  const [animationTwoComplete, setAnimationTwoComplete] = useState(false);
  const [animationThreeComplete, setAnimationThreeComplete] = useState(false);

  useEffect(() => {
    if (animationThreeComplete) {
      setTimeout(() => {
        advanceForm();
      }, 100);
    }
  }, [animationThreeComplete])

  return (
    <div className="ff-animation">
      <h4 className="ff-animation-heading">Powered by data from millions of customers.</h4>
      <p className="ff-animation-box">
        Analyzing your responses
        {animationOneComplete ?
          <SVG icon="check" /> :
          <span className="progress-bar progress-bar-1">
            <span className="progress-bar-fill" onAnimationEnd={() => { setAnimationOneComplete(true) }}></span>
          </span>
        }
      </p>
      <p className="ff-animation-box">
        Checking reviews for this product
        {animationTwoComplete ?
          <SVG icon="check" /> :
          <span className="progress-bar progress-bar-2">
            <span className="progress-bar-fill" onAnimationEnd={() => { setAnimationTwoComplete(true) }}></span>
          </span>
        }
      </p>
      <p className="ff-animation-box">
        Confirming your recommended size
        {animationThreeComplete ?
          <SVG icon="check" /> :
          <span className="progress-bar progress-bar-3">
            <span className="progress-bar-fill" onAnimationEnd={() => { setAnimationThreeComplete(true) }}></span>
          </span>
        }
      </p>
    </div>
  )
}